<div class="voucher-card-secondary-container"  *ngIf="!couponLoading">

    <!-- {{couponLoading}}{{selectedOffer|json}} -->
    <ng-container *ngIf="(selectedOffer?.offerType !== 'no_voucher' && (voucherData.voucher_code)) ||
    selectedOffer?.offerType === 'no_voucher'">
    <div class="cancel">
      <img src="../../../assets/svg/clear_white.svg" (click)="closePanel()">
    </div>
        <div class="voucher-card-secondary-header">
            <div class="voucher-card-secondary-header-icon">
                <img [lazyLoad]="selectedOffer.merchantLogoUrl"
                [defaultImage]="'../../../assets/images/image-coming-soon.png'" alt="app icon">
            </div>
            <div class="voucher-card-secondary-header-details">
                <div class="voucher-card-secondary-header-details-title">{{selectedOffer?.merchantName}}</div>
                <div *ngIf="selectedOffer?.offerTitle" class="voucher-card-secondary-header-details-value">
                    {{selectedOffer?.offerTitle}}
                </div>
                <div *ngIf="!selectedOffer?.offerTitle" class="voucher-card-secondary-header-details-value">
                    <div class="voucher-card-secondary-header-details-value-price">
                        <span class="voucher-card-secondary-header-details-value-price-heading">Denomination</span>
                        <span>300</span>
                    </div>
                    <div class="voucher-card-secondary-header-details-value-price">
                        <span class="voucher-card-secondary-header-details-value-price-heading">Quantity</span>
                        <span>1</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="voucher-card-secondary-body">
            <!-- <div class="coupan-code-box relative" id="redemption_coupon_code"
                *ngIf="selectedOffer?.offerType === 'no_voucher'">
                <span class="fnt-17">
                    <b>No Voucher Required</b>
                </span>
            </div> -->
            <app-poshvine-copy-code *ngIf="selectedOffer?.offerType === 'no_voucher'"
                [isNoVoucherCode]="true"></app-poshvine-copy-code>
            <app-poshvine-copy-code *ngIf="selectedOffer?.offerType !== 'no_voucher'" [title]="'Code'"
                [value]="voucherData.voucher_code"></app-poshvine-copy-code>
            <!-- <app-poshvine-copy-code [title]="'Pin'" [value]="'DH123893473247'"></app-poshvine-copy-code> -->
            <div class="voucher-card-secondary-body-expiry">
                <img [src]="assetsPath+'/svg/calendar.svg'" alt="calendar">
                <span class="voucher-card-secondary-body-expiry-text">Expires on
                  <span [ngStyle]="{'font-weight':800}">
                    {{selectedOffer?.endDate |
                      date:
                      'mediumDate'}}
                  </span>
                 </span>
            </div>
        </div>
        <div class="voucher-card-secondary-footer">
            <span class="voucher-card-secondary-footer-tnc"
                *ngIf="!GlobalConstants.data.personalized_config.coupon_terms_link || !selectedOffer.merchantId">
                Please refer to the Offer Terms and Conditions on how to redeem this offer
            </span>
            <span class="voucher-card-secondary-footer-tnc"
                *ngIf="GlobalConstants.data.personalized_config.coupon_terms_link && selectedOffer.merchantId">
                Please refer to the Offer
                <a href="{{returnCorrectURL}}" target="_blank" class="underline terms-link">
                    Terms and Conditions</a>
                on how to redeem this offer</span>
            <app-poshvine-button [text]="'Redeem'" *ngIf="!redeeming" (click)="goTo()"></app-poshvine-button>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedOffer?.offerType !== 'no_voucher' && !(voucherData.voucher_code)">

      <div class="unavailable-coupon">
        <div class="cross"><img src="../../../assets/svg/cancel-icon.svg" (click)="closePanel()"></div>
        <svg  fill="red"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px"
          y="0px" viewBox="0 0 512.001 512.001" xml:space="preserve" class="mar-top-48"
          style="enable-background: new 0 0 512.001 512.001;">
          <g >
            <path
              d="M503.839,395.379l-195.7-338.962C297.257,37.569,277.766,26.315,256,26.315c-21.765,0-41.257,11.254-52.139,30.102    L8.162,395.378c-10.883,18.85-10.883,41.356,0,60.205c10.883,18.849,30.373,30.102,52.139,30.102h391.398    c21.765,0,41.256-11.254,52.14-30.101C514.722,436.734,514.722,414.228,503.839,395.379z M477.861,440.586    c-5.461,9.458-15.241,15.104-26.162,15.104H60.301c-10.922,0-20.702-5.646-26.162-15.104c-5.46-9.458-5.46-20.75,0-30.208    L229.84,71.416c5.46-9.458,15.24-15.104,26.161-15.104c10.92,0,20.701,5.646,26.161,15.104l195.7,338.962    C483.321,419.836,483.321,431.128,477.861,440.586z">
            </path>
          </g>
          <g >
            <rect  x="241.001" y="176.01" width="29.996" height="149.982"></rect>
          </g>
          <g >
            <path
              d="M256,355.99c-11.027,0-19.998,8.971-19.998,19.998s8.971,19.998,19.998,19.998c11.026,0,19.998-8.971,19.998-19.998    S267.027,355.99,256,355.99z">
            </path>
          </g>
        </svg>
        <div class="fnt-16 ln-28 c333 error-line">Something went wrong. Please try again later!
        </div>
      </div>
    </ng-container>
</div>
<div class="loader" *ngIf="couponLoading">
  <app-loader-cirle [isTransparent]="true"></app-loader-cirle>
</div>


